<template>
  <div class="title">
    <div class="leyenda">
      <p>Registros</p>
      <p>Promocionales</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Auth',

  data () {
    return {
    }
  },
  created() {
  },
  mounted() {
    this.$auth.handleAuthentication()
      .then(() => {
        return this.$store.dispatch('user/loginAuth', this.$auth.user);
      })
      .then(() => this.$router.push({ name: 'Dashboard' }));
  },
  methods: {
  }
}
</script>

<style>
</style>